import type { ParseISOStringsOptions } from "@tellescope/type-correction";
import { TellescopeModelFromName } from "../mappings";

// TODO: use a codemod that will autogenerate a list of fields that should be parsed if they could be a `Date` in the sdk types, and skip all others
const KEYS_TO_PARSE = new Set<keyof TellescopeModelFromName<"endusers">>([
  "_dateOfBirth",
  "createdAt",
  "invalidateSessionsBefore",
  "lastActive",
  "lastAutoreplySentAt",
  "lastZendeskSyncAt",
  "lastDoseSpotSyncAt",
  "lastSuperdialEligibilityCheckAt",
  "lastCommunication",
  "lastLogout",
  "markedReadAt",
  "markedUnreadAt",
  "passwordLastChangedAt",
  "recentActivityAt",
  "recentFormSubmittedAt",
  "recentEventBookedAt",
  "recentOutboundCallAt",
  "recentInboundCallAt",
  "recentOutboundSMSAt",
  "recentInboundChatAt",
  "recentOutboundChatAt",
  "recentInboundSMSAt",
  "recentOutboundEmailAt",
  "recentInboundEmailAt",
  "recentOutboundGroupMMSAt",
  "recentInboundGroupMMSAt",
  "termsSigned",
  "updatedAt",
]);

/**
 * Predicate for parseISOStrings that prevents enduser non-date fields from being parsed incorrectly.
 */
export const endusersISOParsingPredicate = ((_value: unknown, key?: string, parent?: unknown) => {
  if (!parent && key && KEYS_TO_PARSE.has(key as keyof TellescopeModelFromName<"endusers">)) {
    return true;
  }
  return false;
}) satisfies NonNullable<ParseISOStringsOptions["predicate"]>;
